module.exports = __webpack_public_path__ + "media/images/logo_black_small-dc0e6c61190eb66d2aec2bddc8281cf8.png";